import type { DataTableColumn } from '@/components/custom/erp';
import { GroupType, type Group } from '@/types/schemas';

export const exportMainColumns: DataTableColumn<Group>[] = [
  { field: 'ma_nhom', headerName: 'Mã nhóm', width: 150 },
  { field: 'ten_phan_nhom', headerName: 'Tên nhóm', width: 250 }
];

export const groupTypes = [
  { label: 'Nhóm nhà cung cấp 1', value: GroupType.CUSTOMER1 },
  { label: 'Nhóm nhà cung cấp 2', value: GroupType.CUSTOMER2 },
  { label: 'Nhóm nhà cung cấp 3', value: GroupType.CUSTOMER3 }
];

export const exportDetailItemColumns: DataTableColumn<Record<string, unknown>>[] = [
  { field: 'ma_sp', headerName: 'Mã sản phẩm', width: 150 },
  { field: 'ten_sp', headerName: 'Tên sản phẩm', width: 150 },
  { field: 'dvt', headerName: 'Đvt', width: 100 },
  { field: 'ma_kho', headerName: 'Mã kho', width: 120 },
  { field: 'so_luong', headerName: 'Số lượng', width: 120 },
  { field: 'gia_vnd', headerName: 'Giá VND', width: 150 },
  { field: 'tien_hang_vnd', headerName: 'Tiền VND', width: 150 },
  { field: 'tk_vat_tu', headerName: 'Tk vật tư', width: 120 },
  { field: 'thue_suat', headerName: 'Thuế suất', width: 120 },
  { field: 'thue_gtgt_vnd', headerName: 'Thuế GTGT VND', width: 150 },
  { field: 'bo_phan', headerName: 'Bộ phận', width: 140 },
  { field: 'vu_viec', headerName: 'Vụ việc', width: 140 },
  { field: 'hop_dong', headerName: 'Hợp đồng', width: 140 },
  { field: 'dot_thanh_toan', headerName: 'Đợt thanh toán', width: 150 },
  { field: 'khe_uoc', headerName: 'Khế ước', width: 120 },
  { field: 'phi', headerName: 'Phí', width: 100 },
  { field: 'san_pham', headerName: 'Sản phẩm', width: 140 },
  { field: 'lenh_san_xuat', headerName: 'Lệnh sản xuất', width: 150 },
  { field: 'cp_khong_hop_le', headerName: 'C/p không h/lệ', width: 150 },
  {
    field: 'so_hd_trong_nuoc',
    headerName: 'Số hóa đơn mua trong nước',
    width: 200
  },
  {
    field: 'so_hd_nhap_khau',
    headerName: 'Số hóa đơn mua nhập khẩu',
    width: 200
  },
  {
    field: 'so_hd_xuat_thang',
    headerName: 'Số hóa đơn mua xuất thẳng',
    width: 200
  },
  { field: 'dong_hd', headerName: 'Dòng HĐ', width: 120 }
];

export const exportTaxItemColumns: DataTableColumn<Record<string, unknown>>[] = [
  { field: 'so_hoa_don', headerName: 'Số hóa đơn', width: 150 },
  { field: 'ky_hieu', headerName: 'Ký hiệu', width: 150 },
  { field: 'ngay_hoa_don', headerName: 'Ngày hóa đơn', width: 150 },
  { field: 'thue_suat', headerName: 'Thuế suất', width: 150 },
  { field: 'mau_hoa_don', headerName: 'Mẫu hóa đơn', width: 150 },
  { field: 'mau_bao_cao', headerName: 'Mẫu báo cáo', width: 150 },
  { field: 'mau_tinh_chat', headerName: 'Mẫu tính chất', width: 150 },
  { field: 'ma_ncc', headerName: 'Mã NCC', width: 150 },
  { field: 'ten_nha_cung_cap', headerName: 'Tên nhà cung cấp', width: 150 },
  { field: 'dia_chi', headerName: 'Địa chỉ', width: 150 },
  { field: 'ma_so_thue', headerName: 'Mã số thuế', width: 150 },
  {
    field: 'ten_hang_hoa_dich_vu',
    headerName: 'Tên hàng hóa dịch vụ',
    width: 150
  },
  { field: 'tien_hang_vnd', headerName: 'Tiền hàng VND', width: 150 },
  { field: 'tk_thue', headerName: 'Tk thuế', width: 150 },
  { field: 'thue_vnd', headerName: 'Thuế VND', width: 150 },
  { field: 'cuc_thue', headerName: 'Cục thuế', width: 150 },
  { field: 'ma_thanh_toan', headerName: 'Mã thanh toán', width: 150 },
  { field: 'ghi_chu', headerName: 'Ghi chú', width: 150 },
  { field: 'bo_phan', headerName: 'Bộ phận', width: 150 },
  { field: 'vu_viec', headerName: 'Vụ việc', width: 150 },
  { field: 'hop_dong', headerName: 'Hợp đồng', width: 150 },
  { field: 'dot_thanh_toan', headerName: 'Đợt thanh toán', width: 150 },
  { field: 'khe_uoc', headerName: 'Khế ước', width: 150 },
  { field: 'phi', headerName: 'Phí', width: 150 },
  { field: 'san_pham', headerName: 'Sản phẩm', width: 150 },
  { field: 'lenh_san_xuat', headerName: 'Lệnh sản xuất', width: 150 },
  { field: 'cp_khong_hop_le', headerName: 'Chi phí không hợp lệ', width: 150 }
];

export const exportFromPopupDetailItemColumns: DataTableColumn<Record<string, unknown>>[] = [
  { field: 'ma_sp', headerName: 'Mã sản phẩm', width: 150 },
  { field: 'ten_sp', headerName: 'Tên sản phẩm', width: 150 },
  { field: 'dvt', headerName: 'Đvt', width: 150 },
  { field: 'sl_lay', headerName: 'Số lượng lấy', width: 150 },
  { field: 'so_luong', headerName: 'Số lượng', width: 150 },
  { field: 'sl_con_lai', headerName: 'Số lượng còn lại', width: 150 },
  { field: 'ma_kho', headerName: 'Mã kho', width: 150 },
  { field: 'gia_vnd', headerName: 'Giá VND', width: 150 },
  { field: 'tien_vnd', headerName: 'Tiền VND', width: 150 },
  { field: 'tk_kho', headerName: 'Tk kho', width: 150 },
  { field: 'bo_phan', headerName: 'Bộ phận', width: 150 },
  { field: 'vu_viec', headerName: 'Vụ việc', width: 150 },
  { field: 'hop_dong', headerName: 'Hợp đồng', width: 150 },
  { field: 'dot_thanh_toan', headerName: 'Đợt thanh toán', width: 150 },
  { field: 'khe_uoc', headerName: 'Khế ước', width: 150 },
  { field: 'phi', headerName: 'Phí', width: 150 },
  { field: 'san_pham', headerName: 'Sản phẩm', width: 150 },
  { field: 'lenh_san_xuat', headerName: 'Lệnh sản xuất', width: 150 },
  { field: 'cp_khong_hop_le', headerName: 'Chi phí không hợp lệ', width: 150 }
];

export const MaNCCSearchColBasicInfo: DataTableColumn<Record<string, unknown>>[] = [
  { field: 'code', headerName: 'Mã đối tượng', flex: 1 },
  { field: 'supplier_name', headerName: 'Tên đối tượng', flex: 2 },
  { field: 'tax_code', headerName: 'Công nợ phải trả', flex: 1 },
  { field: 'address', headerName: 'Mã số thuế', flex: 1 },
  { field: 'employee', headerName: 'email', flex: 1 },
  { field: 'phone', headerName: 'Điện thoại', flex: 1 }
];
export const TKSearchColBasicInfo: DataTableColumn<Record<string, unknown>>[] = [
  { field: 'code', headerName: 'Mã tài khoản', flex: 1 },
  { field: 'account_name', headerName: 'Tên tài khoản', flex: 2 },
  { field: 'parent_account', headerName: 'Tài khoản mẹ ', flex: 1 },
  { field: 'ledger_account', headerName: 'Tài khoản sổ cái', flex: 1 },
  { field: 'is_group', headerName: 'Tài khoản chi tiết', flex: 1 },
  { field: 'account_level', headerName: 'Bậc tài khoản', flex: 1 }
];

export const MaNVSearchColBasicInfo: DataTableColumn<Record<string, unknown>>[] = [
  { field: 'code', headerName: 'Mã nhân viên', flex: 1 },
  { field: 'employee_name', headerName: 'Tên nhân viên', flex: 2 }
];

export const MaCTSearchColBasicInfo: DataTableColumn<Record<string, unknown>>[] = [
  { field: 'code', headerName: 'Mã quyển', flex: 1 },
  { field: 'document_name', headerName: 'Tên quyển', flex: 2 },
  { field: 'document_type', headerName: 'Sổ khai báo', flex: 1 }
];
